import { RouteType } from 'types/RouteType';
import { ServiceStoreType } from 'types/ServiceStoreTypes';
// import UserManagementIcon from '@mui/icons-material/Face';

const userManagementRoute: RouteType[] = [
  {
    name: 'User Management',
    path: '/user-management',
    layout: '/app',
    viewportCard: {
      header: {
        title: 'User Management',
        // You'll need to create a UserManagement.Header component
        // component: () => import('./UserManagement.Header'),
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        // You'll need to create a UserManagement.Body component and move the logic from UserManagement.Container to it.
        // component: () => import('./UserManagement.Body'),
        gridContainer: {
          namespace: 'UserManagementDataGrid',
          storeName: 'userStore',
          // customEntity: 'userList',
          // fixedRowCount: 2,
          columnHeaders: [
            {
              width: 280,
              key: 'email',
              title: 'User',
              disableEdit: true,
            },

            {
              width: 200,
              key: 'firstName',
              title: 'First Name',
            },
            {
              width: 200,
              key: 'lastName',
              title: 'Last Name',
            },
            {
              width: 150,
              key: 'department',
              title: 'Department',
              choices: [
                'Administration',
                'Engineering & Design',
                'Logistics',
                'Maintenance',
                'Production',
                'Quality & Safety',
                'Sales & Marketing',
              ],
            },
            {
              width: 150,
              key: 'team',
              title: 'Team',
              choices: [
                'Purchasing & Procurement',
                'Finance & Accounting',
                'Human Resources',
                'IT',
                'Structural Design',
                'Drafting & Detailing',
                'CAD/BIM',
                'Dispatch',
                'Yard Management',
                'Inventory Control',
                'Transportation',
                'Shipping & Receiving',
                'Preventative Maintenance',
                'Repair & Troubleshooting',
                'Formwork',
                'Production Control',
                'Production Planning',
                'Finishing',
                'Reinforcement',
                'Casting',
                'Curing',
                'Safety',
                'Quality Assurance',
                'Quality Control',
                'Marketing',
                'Sales',
                'Estimating',
                'Customer Service',
              ],
            },
          ],
          defaultSort: {
            sortBy: ['email'],
            sortDirection: { email: 'ASC' },
          },

          enableInlineEdit: true,
          enableHover: true,
          onSubmitEdits: (id, data, rootStore) => {
            console.log('onSubmitEdits', id, data, rootStore);
            const userStore = rootStore.userStore as ServiceStoreType;
            userStore.patch(Number(id), data as object);
          },
        },
      },
    },
    // icon: UserManagementIcon, // This might not be needed anymore, depends on how the new routing handles icons.
    // Might need to be adapted to the new routing structure.
    // Might need to be adapted to the new routing structure.
    group: 'Administration',
    hidden: false, // Might need to be adapted to the new routing structure.
    requiresAuth: false, //  You should define whether authentication is required.
    requiresPermission: false,
    requiresAdmin: true,
    enableAutoFind: false,
    channels: ['user', 'departments'],
    onEnter: async ({ rootStore }) => {
      const userStore = rootStore.userStore as ServiceStoreType;
      const departmentsStore = rootStore.departmentsStore as ServiceStoreType;

      userStore.find();
      departmentsStore.find();
    },
  },
];

export default userManagementRoute;
